import { render, staticRenderFns } from "./MobileSubArticle.vue?vue&type=template&id=a7ba32ec&"
import script from "./MobileSubArticle.vue?vue&type=script&lang=js&"
export * from "./MobileSubArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports